var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobilePhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "269px",
    height: "137px",
    viewBox: "0 0 269 137",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.0412 0.3305 46.084 0.3305 46.084 46.3735 0.0412 46.3735"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.1---Mobile",
    transform: "translate(-53.000000, -330.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(54.000000, 331.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.5419,83.9003 C117.5419,112.4233 94.4189,135.5463 65.8959,135.5463 C37.3709,135.5463 14.2479,112.4233 14.2479,83.9003 C14.2479,55.3763 37.3709,32.2533 65.8959,32.2533 C94.4189,32.2533 117.5419,55.3763 117.5419,83.9003",
    id: "Fill-1",
    fill: "#E7ECFE"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.5966,
    y1: 48.744,
    x2: 58.7396,
    y2: -2.84217094e-14,
    id: "Stroke-24",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51.828,
    y1: 113.5907,
    x2: 2.13162821e-13,
    y2: 129.6837,
    id: "Stroke-26",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(220.977100, 45.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3442,4.5505 C32.5962,1.8895 28.0192,0.3305 23.0712,0.3305 C22.9702,0.3305 22.8692,0.3305 22.7702,0.3445 C19.6222,0.3735 16.6192,1.0455 13.9022,2.2335 C5.7482,5.7665 0.0412,13.8905 0.0412,23.3455 C0.0412,36.0615 10.3542,46.3735 23.0712,46.3735 C24.2722,46.3735 25.4452,46.2875 26.5892,46.1025 C28.7782,45.7735 30.8652,45.1295 32.7962,44.2145 C38.6902,41.4675 43.2242,36.2895 45.1122,29.9675 C45.7412,27.8645 46.0842,25.6485 46.0842,23.3455 C46.0842,15.5785 42.2372,8.7125 36.3442,4.5505",
    id: "Fill-11",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M206,73.2223 C206,90.6293 219.789,104.7333 236.781,104.7333",
    id: "Stroke-14",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.912,43.956 C259.912,50.283 254.783,55.412 248.456,55.412 C242.129,55.412 237,50.283 237,43.956 C237,37.629 242.129,32.5 248.456,32.5 C254.783,32.5 259.912,37.629 259.912,43.956 Z",
    id: "Stroke-30",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(89.500000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.344509,107.811023 L4.25750903,87.0040232 C0.010509033,84.3330232 -1.27849097,78.6730232 1.39250903,74.4260232 L45.517509,4.2580232 C48.188509,0.0110232046 53.848509,-1.2789768 58.095509,1.3920232 L91.182509,22.2000232 C95.429509,24.8710232 96.719509,30.5300232 94.048509,34.7770232 L49.922509,104.945023 C47.251509,109.192023 41.591509,110.482023 37.344509,107.811023",
    id: "Fill-64",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.344509,107.811023 L4.25750903,87.0040232 C0.010509033,84.3330232 -1.27849097,78.6730232 1.39250903,74.4260232 L45.517509,4.2580232 C48.188509,0.0110232046 53.848509,-1.2789768 58.095509,1.3920232 L91.182509,22.2000232 C95.429509,24.8710232 96.719509,30.5300232 94.048509,34.7770232 L49.922509,104.945023 C47.251509,109.192023 41.591509,110.482023 37.344509,107.811023 Z",
    id: "Stroke-65",
    stroke: "#1D1D1B",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.142309,105.168423 L4.25730903,87.0044232 C0.010309033,84.3334232 -1.27869097,78.6734232 1.39230903,74.4264232 L45.517309,4.2584232 C48.188309,0.0114232046 53.848309,-1.2785768 58.095309,1.3924232 L86.980309,19.5574232 C91.227309,22.2284232 92.517309,27.8884232 89.846309,32.1354232 L45.720309,102.302423 C43.049309,106.549423 37.389309,107.839423 33.142309,105.168423",
    id: "Fill-66",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.142309,105.168423 L4.25730903,87.0044232 C0.010309033,84.3334232 -1.27869097,78.6734232 1.39230903,74.4264232 L45.517309,4.2584232 C48.188309,0.0114232046 53.848309,-1.2785768 58.095309,1.3924232 L86.980309,19.5574232 C91.227309,22.2284232 92.517309,27.8884232 89.846309,32.1354232 L45.720309,102.302423 C43.049309,106.549423 37.389309,107.839423 33.142309,105.168423 Z",
    id: "Stroke-67",
    stroke: "#1D1D1B",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.772209,102.951623 L5.54920903,84.5746232 C2.82220903,82.8596232 1.99420903,79.2246232 3.70920903,76.4976232 L48.388209,5.4496232 C50.103209,2.7226232 53.738209,1.8936232 56.465209,3.6086232 L85.689209,21.9856232 C88.417209,23.7016232 89.245209,27.3366232 87.529209,30.0636232 L42.849209,101.111623 C41.134209,103.839623 37.500209,104.667623 34.772209,102.951623",
    id: "Fill-68",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.772209,102.951623 L5.54920903,84.5746232 C2.82220903,82.8596232 1.99420903,79.2246232 3.70920903,76.4976232 L48.388209,5.4496232 C50.103209,2.7226232 53.738209,1.8936232 56.465209,3.6086232 L85.689209,21.9856232 C88.417209,23.7016232 89.245209,27.3366232 87.529209,30.0636232 L42.849209,101.111623 C41.134209,103.839623 37.500209,104.667623 34.772209,102.951623 Z",
    id: "Stroke-69",
    stroke: "#1D1D1B",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-72",
    transform: "translate(67.448609, 10.299323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.9154,4.1641 L4.6354,5.4441 C4.3044,5.6301 3.8984,5.6191 3.5774,5.4181 L0.8794,3.7211 C0.5584,3.5181 0.3734,3.1571 0.3964,2.7791 L0.5624,0.1691",
    id: "Fill-70",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9154,4.1641 L4.6354,5.4441 C4.3044,5.6301 3.8984,5.6191 3.5774,5.4181 L0.8794,3.7211 C0.5584,3.5181 0.3734,3.1571 0.3964,2.7791 L0.5624,0.1691",
    id: "Stroke-71",
    stroke: "#1D1D1B",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.766309,13.2807232 L70.635309,13.1987232 C70.496309,13.1117232 70.454309,12.9267232 70.542309,12.7887232 L70.623309,12.6577232 C70.711309,12.5187232 70.896309,12.4767232 71.035309,12.5637232 L71.164309,12.6457232 C71.303309,12.7337232 71.346309,12.9187232 71.258309,13.0567232 L71.176309,13.1867232 C71.089309,13.3257232 70.905309,13.3677232 70.766309,13.2807232",
    id: "Fill-73",
    fill: "#FAEFE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.766309,13.2807232 L70.635309,13.1987232 C70.496309,13.1117232 70.454309,12.9267232 70.542309,12.7887232 L70.623309,12.6577232 C70.711309,12.5187232 70.896309,12.4767232 71.035309,12.5637232 L71.164309,12.6457232 C71.303309,12.7337232 71.346309,12.9187232 71.258309,13.0567232 L71.176309,13.1867232 C71.089309,13.3257232 70.905309,13.3677232 70.766309,13.2807232 Z",
    id: "Stroke-74",
    stroke: "#1D1D1B",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-75",
    fill: "#FFF6E7",
    points: "71.838609 55.0141232 17.398609 54.7291232 28.605609 36.9081232 83.046609 37.1931232"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-76",
    fill: "#FFF6E7",
    points: "66.093509 64.1509232 11.653509 63.8659232 15.128509 58.3389232 69.569509 58.6239232"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.780009,
    y1: 35.0405232,
    x2: 10.205009,
    y2: 66.1675232,
    id: "Stroke-77",
    stroke: "#1D1D1B",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.967509,
    y1: 34.1372232,
    x2: 61.886509,
    y2: 70.8402232,
    id: "Stroke-78",
    stroke: "#1D1D1B",
    strokeWidth: 0.5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePhone);
export default __webpack_public_path__ + "static/media/mobilePhone.6696b2167acdb896f0e7769ad263593a.svg";
export { ForwardRef as ReactComponent };